<script setup lang="ts">
import ShipTableRow from '@/components/ships/ShipTableRow.vue'
import ShipPreviewParameterTableHeader from '@/components/import/ShipPreviewParameterTableHeader.vue'
import type { ShipType } from '@/stores/type/ship.type'
import type { PropType } from 'vue'

const props = defineProps({
  ship: { type: Object as PropType<ShipType>, required: true },
  chartEvent: { type: String as PropType<string>, required: true },
  tableHeight: { type: Number, default: 70 }
})
</script>

<template>
  <v-data-table ref="shipPreviewTable">
    <template v-slot:thead>
      <ShipPreviewParameterTableHeader />
    </template>
    <template v-slot:body>
      <ShipTableRow
        :chart-event="chartEvent"
        :table-height="tableHeight"
        :item="ship"
        :preview-state="true"
      ></ShipTableRow>
    </template>
    <template v-slot:bottom></template>
  </v-data-table>
</template>
